<template>
  <div>
    <div class="m-b-24">
      <el-dropdown @command="visable" trigger="click" v-if="this.$hasPerm('HK002')">
        <el-button plain size="small">
          导出 <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="exportEmail">导出至邮箱</el-dropdown-item>
          <el-dropdown-item command="exportExcel">导出至Excel</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>

</template>
<script>
export default {
  props: {
    searchReq: {
      type: Object,
      required: true
    }
  },
  mounted() {
  },
  data() {
    return {
    };
  },
  methods: {
    exportCheck() {
      this.$ajax({
        url: '/pay/exportCheck',
        data: this.searchReq
      }).then(() => {
        this.exportExcel();
      });
    },
    exportExcel() {
      this.searchReq.Authorization = localStorage.getItem('authorization');
      const fileUrl = `${this.$url}/pay/exportExcel`;
      const form = document.createElement('form');
      form.setAttribute('action', fileUrl);
      form.setAttribute('method', 'get');
      form.setAttribute('id', 'download');
      document.body.appendChild(form);
      Object.keys(this.searchReq).forEach((key) => {
        const value = this.searchReq[key];
        if (value != null) {
          const input = document.createElement('input');
          input.setAttribute('name', key);
          input.setAttribute('value', value);
          input.style.display = 'none';
          form.appendChild(input);
        }
      });
      const ttt = form.submit();
      console.warn(ttt);
      setTimeout(() => {
        const parent = document.querySelector('#download');
        const childs = parent.childNodes;
        for (let i = childs.length - 1; i >= 0; i--) {
          parent.removeChild(childs[i]);
        }
        document.body.removeChild(form);
      }, 1000);
    },
    exportEmail() {
      this.$confirm('您确认要导出还款信息到邮箱?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          url: '/pay/exportEmail',
          data: this.searchReq
        }).then(() => {
          this.$message({
            message: `还款列表导出成功,稍候将发送到您的邮箱，请注意查收（${this.$account().email}）`,
            type: 'success'
          });
        });
      });
    },
    visable(command) {
      if (command === 'exportExcel') {
        this.$confirm('您确认要导出Excel?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.exportCheck();
        });
      }
      if (command === 'exportEmail') {
        this.exportEmail();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/repay/listOperate.vue